import React from 'react';
import { BundleCard } from './BundleCard';
export function MiniBundles() {
  const productImage = 'https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png';
  const bundles = [{
    qty: 1,
    price: '34,95 €',
    original: '49,95 €',
    savings: 30
  }, {
    qty: 2,
    price: '54,95 €',
    original: '79,95 €',
    savings: 31
  }, {
    qty: 3,
    price: '64,95 €',
    original: '99,95 €',
    savings: 35,
    best: true
  }, {
    qty: 6,
    price: '99,95 €',
    original: '159,95 €',
    savings: 38
  }];
  return <div className="bg-white border-b border-gray-100 py-8 hidden md:block" data-id="element-459">
      
    </div>;
}